/* globals Geocomplete, PropTypes */

import { useEffect, useRef, useState } from 'react'
import cn from 'classnames'

export default function AddressInput (props) {
  const [value, setValue] = useState(props.value)
  const [focused, setFocused] = useState(false)
  const nestedName = props.nestedInline ? '[address_attributes]' : ''
  const namePrefix = `${props.name.split('[')[0]}${nestedName}`
  const elementRef = useRef(null)
  const searchInputRef = useRef(null)
  const searchDetailsRef = useRef(null)

  const validate = (_e) => {
    setTimeout(() => {
      const searchDetails = $(searchDetailsRef.current)
      const coords = searchDetails.find('[data-search-geo="lat"]').val() && searchDetails.find('[data-search-geo="lng"]').val()
      $(elementRef.current).removeClass('focused')
      if ($(searchInputRef.current).val() && !coords) {
        $(elementRef.current).addClass('has-error')
        $(elementRef.current).parents('.form-group').addClass('has-error')
      } else {
        $(elementRef.current).removeClass('has-error')
        $(elementRef.current).parents('.form-group').removeClass('has-error')
      }
    }, 300)
  }

  const inputChange = (e) => {
    $(elementRef.current).removeClass('has-error')
    setValue(e.target.value)
  }

  const getValue = (name) => {
    if (props.value && props.values) return props.values[name] || ''
    return ''
  }

  const clear = () => {
    $(elementRef.current).find('input').val('').trigger('change')
    setValue(null)
  }

  useEffect(() => {
    if (!props.hidden) {
      $(searchInputRef.current).on('geocode:result', validate())
      Geocomplete.initSelect({
        input: $(searchInputRef.current),
        details: $(searchDetailsRef.current),
        details_attr: 'data-search-geo'
      })
    }
  }, [])

  const classes = cn({
    'show-labelholder': value,
    focused
  }, 'labelholder')

  return (
    <>
      <div className='error help-block'>{I18n.t('searches.location_error')}</div>
      <div
        className={classes}
        ref={elementRef}
        data-label={props.hidden ? '' : props.placeholder || ''}
      >

        <input
          type={props.hidden ? 'hidden' : 'text'}
          className={cn('form-control', { 'has-value': value })}
          value={value || ''}
          name={props.name}
          placeholder={props.placeholder || ''}
          onChange={inputChange}
          onBlur={validate}
          onFocus={() => setFocused(true)}
          id={props.field}
          ref={searchInputRef}
        />
        <div className='remover' onClick={clear} />
        <div className='search-details' ref={searchDetailsRef}>
          <input data-search-geo='lat' type='hidden' name={`${namePrefix}[lat]`} value={getValue('lat')} />
          <input data-search-geo='lng' type='hidden' name={`${namePrefix}[lng]`} value={getValue('lng')} />
          <input data-search-geo='postal_code' type='hidden' name={`${namePrefix}[zip]`} value={getValue('zip')} />
          <input data-search-geo='locality' type='hidden' name={`${namePrefix}[city]`} value={getValue('city')} />
          <input data-search-geo='administrative_area_level_1' type='hidden' name={`${namePrefix}[region]`} value={getValue('region')} />
          <input data-search-geo='country_short' type='hidden' name={`${namePrefix}[country_code]`} value={getValue('country_code')} />
          <input data-search-geo='street_address' type='hidden' name={`${namePrefix}[street]`} value={getValue('street')} />
        </div>
      </div>
    </>
  )
}

AddressInput.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  field: PropTypes.string.isRequired,
  values: PropTypes.object,
  hidden: PropTypes.bool
}
